import * as B from '@blueprintjs/core';
import React from 'react';

import cs from './styles.module.scss';
import {RunPlanDraft} from './types';

// Nothing schedules a plan yet, so a run happens when someone asks for it.
const FREQUENCY_OPTIONS = [
  {value: 'manual', label: 'Manual only'},
  {value: 'weekly', label: 'Weekly (coming soon)', disabled: true},
  {value: 'monthly', label: 'Monthly (coming soon)', disabled: true},
];

export const DetailsStep: React.FC<{
  draft: RunPlanDraft;
  setDraft: (patch: Partial<RunPlanDraft>) => void;
  suggestedTitle: string;
}> = ({draft, setDraft, suggestedTitle}) => (
  <div className={cs.step}>
    <B.FormGroup label="Name this run plan" labelFor="run-plan-title-input">
      <B.InputGroup
        id="run-plan-title-input"
        value={draft.title}
        onValueChange={(title) => setDraft({title})}
        placeholder={suggestedTitle}
        fill
      />
    </B.FormGroup>
    <B.FormGroup
      label="Schedule"
      labelFor="run-plan-frequency-select"
      className={cs.frequencyField}
    >
      {/* Uncontrolled: there's only one selectable option, so nothing reads it back. */}
      <B.HTMLSelect
        id="run-plan-frequency-select"
        defaultValue="manual"
        options={FREQUENCY_OPTIONS}
        fill
      />
    </B.FormGroup>
  </div>
);
